module.exports = __webpack_public_path__ + "img/snow_fall_00010.a88b06d1.png";